export enum ContractPeriod {
    cpAny = 0,
    cpDay = 1,
    cpWeek = 2,
    cpMonth = 3,
    cpQuarter = 4,
    cpSixMonth = 5,
    cpYear = 6,
    cpFixed = 7
}